/**
* 数据中心平台 首页
*/
export const CHANGEPAGE = 'CHANGEPAGE' // 切换页面·
export const GETMAPLIST = 'GETMAPLIST' // 获取地图数据·
export const GETPAYAMOUNT = 'GETPAYAMOUNT' // 获取每日支付金额统计
export const GETWAREHOUSEINCOME = 'GETWAREHOUSEINCOME' // 仓库收入统计
export const GETSALESRANK = 'GETSALESRANK' // 近30天商品销量排行TOP10
export const GETPLATFORMSHIPMENT = 'GETPLATFORMSHIPMENT' // 上月配送平台出货量统计
export const GETSUPPLYACTIVE = 'GETSUPPLYACTIVE' // 供应商活跃度
export const GETWAREHOUSETASK = 'GETWAREHOUSETASK' // 单仓日平均完成任务数TOP5

export const GETWAREHOUSEREVENUESTATISTICAL = 'GETWAREHOUSEREVENUESTATISTICAL'
export const GETSUPPLIERDATASTATISTICAL = 'GETSUPPLIERDATASTATISTICAL'
export const GETSUPPLIERDATATOP20 = 'GETSUPPLIERDATATOP20'
export const GETSUPPLYDATAAXIS = 'GETSUPPLYDATAAXIS' // 供应商无数据时返回x轴坐标
export const GETSUPPLIERDATATOPDETAIL = 'GETSUPPLIERDATATOPDETAIL'
export const EXPORTSUPPLIERDATATOPDETAIL = 'EXPORTSUPPLIERDATATOPDETAIL'
export const GETGOODSDATATOP20 = 'GETGOODSDATATOP20'
export const GETGOODSREVENUESTATISTICAL = 'GETGOODSREVENUESTATISTICAL'
export const GETGOODSDATATOPDETAIL = 'GETGOODSDATATOPDETAIL'
export const EXPORTGOODSDATATOPDETAIL = 'EXPORTGOODSDATATOPDETAIL'
export const GETALLGOOD = 'GETALLGOOD'
export const SUPPLIER = 'SUPPLIER'
export const GOODSUPPLIER = 'GOODSUPPLIER'

/**
* 仓库出入库统计
*/
export const GETALLWAREHOUSE = 'GETALLWAREHOUSE' // 获取仓库下拉框
export const GETALLTASK = 'GETALLTASK' // 获取仓库出入库数量
export const GETOUTTASKWEIGHTANDVOLUME = 'GETOUTTASKWEIGHTANDVOLUME' // 获取出库商品重量/体积
export const GETENTERTASK = 'GETENTERTASK' // 获取仓库入库数量占比
export const GETSELLTASK = 'GETSELLTASK' // 获取仓库出库数量占比

/**
* 数据中心平台 首页（saas）
*/
export const GETGOODSSTOCKS = 'GETGOODSSTOCKS'
export const GETWAREHOUSEDISTRIBUTIONMAP = 'GETWAREHOUSEDISTRIBUTIONMAP'
export const GETMERCHANTTOTALINVENTORYRANKING = 'GETMERCHANTTOTALINVENTORYRANKING'
export const GETCOMMODITYSALESRANKING = 'GETCOMMODITYSALESRANKING'
export const GETTHETOTALAMOUNTOFBILLSPAIDACROSSTHEPLATFORM = 'GETTHETOTALAMOUNTOFBILLSPAIDACROSSTHEPLATFORM'
export const GETCATEGORYSALESRATIO = 'GETCATEGORYSALESRATIO'

/**
 * 商品分析（saas端）
 */
export const GETGOODSREVENAUESTATISTICAL = 'GETGOODSREVENAUESTATISTICAL'
export const GETCATEGORYSALESHEATMAP = 'GETCATEGORYSALESHEATMAP'
export const GETGOODSCATEGORYSELECT = 'GETGOODSCATEGORYSELECT'
/**
 * 商户统计（saas端）
 */
export const GETBASICINFORMATION = 'GETBASICINFORMATION'
export const GETDAILYSHIPMENTS = 'GETDAILYSHIPMENTS'
export const GETAMOUNTOFBILLSPAIDPERMONTH = 'GETAMOUNTOFBILLSPAIDPERMONTH'
export const GETMERCHANTSELECT = 'GETMERCHANTSELECT'
/**
 * 供应商统计
 */
export const DATASUPPLIER = 'DATASUPPLIER'



// WEBPACK FOOTER //
// ./src/store/dataCenter/types.js